import routes from '@/config/routes';
import { v3Get, v3Post } from '@/api/axios.instance.V3';
import type { ApiResponse } from '@/api/types';
import type { ISetInterviewSlotForSP } from '@/store/types';
const getAvailableInterviewSlotsByCampaignId = (campaignId: number): ApiResponse => {
  return v3Get(`${routes.backendUrl.interviews.getSlotsByCampaignAndDate}/${campaignId}`);
};
const saveInterviewSlotSelection = (payload: ISetInterviewSlotForSP): ApiResponse => {
  return v3Post(`${routes.backendUrl.interviews.saveInterviewSlotSelection}`, payload);
};
export const interviewsApi = {
  getAvailableInterviewSlotsByCampaignId,
  saveInterviewSlotSelection,
};
